import { formatToLocaleNumber, getIconByName } from "src/utils";
import styles from "./TrendAlertConfirmation.module.scss";
import { FC } from "react";
import { Preloader } from "src/components";

type Props = {
  createdAlert: TrendAlert.Data | null;
  editMode: boolean;
};

export const TrendAlertConfirmation: FC<Props> = ({
  createdAlert,
  editMode,
}) => {
  if (!createdAlert) {
    return (
      <div className={styles.container}>
        <div className={styles.loader}>
          <Preloader />
        </div>
      </div>
    );
  }

  const data = [
    { label: "Topic", value: createdAlert.trackerName },
    { label: "Condition", value: createdAlert.condition },
  ];

  if (["consistent", "oneTime"].includes(createdAlert.type)) {
    data.push(
      {
        label: "Target volume",
        value:
          createdAlert.type !== "oneTime"
            ? `${formatToLocaleNumber(createdAlert.targetVolume)} (${
                createdAlert.percentage
              }%)`
            : formatToLocaleNumber(createdAlert.targetVolume),
      },
      {
        label: "Current volume",
        value: formatToLocaleNumber(createdAlert.baseVolume),
      },
    );
  } else {
    data.push({
      label: "Min volume",
      value: formatToLocaleNumber(createdAlert.minVolume ?? 0),
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.icon}>{getIconByName("CheckMark")}</div>
      <h3>
        Trend Alert has been successfully
        {` ${editMode ? " updated" : " created"}`}
      </h3>
      <table className={styles.table}>
        <tbody>
          {data.map(({ label, value }, index) => (
            <tr key={index} className={styles.row}>
              <td className={styles.label}>{label}</td>
              <td className={styles.value}>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
